import PropTypes from 'prop-types';
import "./assets/menus.scss";

const BlockMenu = ({ title, iconClass, headerActions, expanded, setExpanded, children }) => {


    return (
        <>
            {expanded && (
                <div className="menu fixed-block-menu mb-3">
                    <div className="sticky-menu-header fixed-menu-header">
                        <div className="fixed-menu-header-title">
                            {iconClass && (<i className={`bi ${iconClass} me-2 my-auto`}></i>)}
                            <h5 className="my-auto">
                                {`${iconClass && " "}${title}`}
                            </h5>
                        </div>
                        <div className="fixed-menu-header-actions">
                            {headerActions}
                            <button
                                className="btn-close btn-close-sm"
                                onClick={() => setExpanded(false)}
                                title="Close gallery"
                                aria-label="Close"
                            />
                        </div>
                    </div>
                    <div className="menu-content pt-3 pb-3 p-3">
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};


BlockMenu.propTypes = {
    title: PropTypes.string.isRequired,
    iconClass: PropTypes.string,
    headerActions: PropTypes.node,
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default BlockMenu;
